// extracted by mini-css-extract-plugin
export var container = "components-modals-__EditPinCode-module___container";
export var header = "components-modals-__EditPinCode-module___header";
export var modalActionsWrapper = "components-modals-__EditPinCode-module___modalActionsWrapper";
export var submit = "components-modals-__EditPinCode-module___submit";